/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// Import global styles
import './src/index.css'

// Add service worker update prompt for better PWA experience
export const onServiceWorkerUpdateReady = () => {
  const answer = window.confirm(
    'This wedding invitation has been updated. ' +
      'Reload to display the latest version?'
  )

  if (answer === true) {
    window.location.reload()
  }
}

// Optimize page transitions
export const shouldUpdateScroll = () => {
  return false
}

// Prevent flash of unstyled content
export const onClientEntry = () => {
  // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
  if (!('IntersectionObserver' in window)) {
    import('intersection-observer')
    console.log('# IntersectionObserver is polyfilled!')
  }
}

